import { create } from 'zustand';

interface InstagramInboxState {
  selectedConversationId: string | null;
  showAgentConfig: boolean;
  setSelectedConversation: (id: string | null) => void;
  clearSelectedConversation: () => void;
  toggleAgentConfig: () => void;
  setShowAgentConfig: (show: boolean) => void;
}

export const useInstagramInboxStore = create<InstagramInboxState>((set) => ({
  selectedConversationId: null,
  showAgentConfig: false,
  setSelectedConversation: (id) => set({ selectedConversationId: id }),
  clearSelectedConversation: () => set({ selectedConversationId: null }),
  toggleAgentConfig: () => set((s) => ({ showAgentConfig: !s.showAgentConfig })),
  setShowAgentConfig: (show) => set({ showAgentConfig: show }),
}));
